import { registerLocaleData } from '@angular/common';
import zh from '@angular/common/locales/zh';
import { destroyPlatform, enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
// 以下兩行僅供已停用的 setHotjarUser 使用，一併註解（ALL-13340，見下方說明）
// import { AccountInforData } from './app/shared/interfaces/account.interface';
// import { LOCAL_USER_INFO, LocalKeyPrefix } from './app/shared/service/localstorage.service';
import { sentryInit } from './app/shared/service/sentry.service';
import { environment } from './environments/environment';

registerLocaleData(zh);

if (environment.production) {
  enableProdMode();
  if (environment.isOnline) {
    window.console.log = function () {};
    window.console.info = function () {};
    window.console.warn = function () {};
    window.console.debug = function () {};
    // window.console.error = function () { };
  }
}

/**
 * 已停用行為追蹤的使用者識別 (Hotjar) — ALL-13340
 *
 * 原本功能：把 uid、前端版本、商戶代號 (m9)、環境 (prod/uat/sit) 以 hj('identify') 送進 Hotjar
 *           session，讓錄製到的操作影片能對應到具體帳號。由 account.api.ts 的
 *           getUserAccountInfor() 在取得使用者資料後呼叫。
 *           外層 `'hj' in window` 是保護：Hotjar SDK 沒載入時直接跳過。
 * 停用原因：JP88 (jackpot88.io) 與各鏡像站都沒有使用 Hotjar，index.html 的 SDK 載入已一併註解。
 * 恢復方式：取消本段與檔案上方兩行 import 的註解，並還原 index.html、account.api.ts、extension.d.ts。
 */
// (window.setHotjarUser = () => {
//   if ('hj' in window && typeof window.hj === 'function') {
//     const userString = window.localStorage.getItem(LocalKeyPrefix + LOCAL_USER_INFO) || 'null';
//     const user: AccountInforData | null = JSON.parse(userString);
//     const uid = user?.uid ?? null;
//     const appversion = environment.version;
//     const tpid = 'm9';
//     const env = environment.isOnline ? 'prod' : environment.isUat ? 'uat' : 'sit';
//     window.hj('identify', uid, { tpid, appversion, env });
//   }
// })();

sentryInit();

(build => {
  if (window.isSupportWebp) document.body.classList.add('is-support-webp');
  window.eventBank = [];
  window.reBuild = () => {
    //显示全局 global-waiting
    const el: HTMLDivElement | null = document.querySelector('.global-waiting');
    if (el) el.style.display = 'flex';
    //销毁重建
    destroyPlatform();
    //清理无用dom
    document.querySelectorAll('.botion_captcha.botion_bind').forEach(x => x.remove());
    const rootElement = document.querySelector('app-root');
    if (!rootElement) {
      const wrap: HTMLDivElement | null = document.querySelector('#root_con_wrap');
      const root = document.createElement('app-root');
      wrap && wrap.appendChild(root);
    }
    build();
  };
  build();
})(() => platformBrowserDynamic().bootstrapModule(AppModule).catch());
